(function() {
    'use strict';

    angular.module('app').service('UIObjectWindow', UIObjectWindowFactory);

    UIObjectWindowFactory.$inject = ['$compile'];

    function UIObjectWindowFactory($compile) {
        function UIObjectWindow() {
            this.instance = null;
        }

        UIObjectWindow.prototype.compile = function(scope) {
            this.instance = new InfoBox({
                visible: false,
                disableAutoPan: true,
                zIndex: 2,
                boxClass: 'box-object-market-window',
              });

              var content = $compile('<object-window object="vehicles.getSelected()" api="owApi"></object-window>')(scope);
              this.instance.setContent(content[0]);

              return this;
        }

        UIObjectWindow.prototype.open = function(map) {
            this.instance.open(map);

            return this;
        }

        UIObjectWindow.prototype.position = function(latitude, longitude) {
            this.instance.setPosition(new google.maps.LatLng(latitude, longitude));

            return this;
        }

        UIObjectWindow.prototype.show = function() {
            this.instance.setVisible(true);

            return this;
        }

        UIObjectWindow.prototype.hide = function() {
            this.instance.setVisible(false);

            return this;
        }

        return UIObjectWindow;
    }
})();
